import clm from "country-locale-map";

export const getCallingCodeByTimezone = () => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const country = clm.getAllCountries().find(
      (c) => Array.isArray(c.timezones) && c.timezones.includes(tz)
    );
    if (country?.callingCode) {
      return `+${country.callingCode}`;
    }
  } catch (_) {
    // Intl not supported or timezone unrecognized, fall back to default
  }
  return "+91";
};

export const getCountryFlag = (countryCode) => {
  if (!countryCode) return "";
  const alpha2 = countryCode.length === 3 ? clm.getAlpha2ByAlpha3(countryCode) : countryCode;
  if (!alpha2) return "";
  const normalized = alpha2.toUpperCase();
  if (!/^[A-Z]{2}$/.test(normalized)) return "";
  return normalized
    .split("")
    .map((char) => String.fromCodePoint(0x1f1e6 - 65 + char.charCodeAt(0)))
    .join("");
};

const flagCache = {};
export const getCachedFlag = (countryCode) => {
  if (flagCache[countryCode] !== undefined) return flagCache[countryCode];
  flagCache[countryCode] = getCountryFlag(countryCode);
  return flagCache[countryCode];
};

export const normalizeLengths = (lengths) => {
  if (!lengths) return [];
  return Array.isArray(lengths) ? lengths : [lengths];
};

export const cityMasterTemplateStrings = {
    name: 'City',
    country:'Country',
    timeZone:'Time Zone',
    timeOffsetMs: 'Time Offset(ms)',
    liveTracking:'Live Tracking',
    status: 'Status',
    action: 'Action'
};

export const countryMasterTemplateStrings = {
    name: 'Country',
    countryCode: 'Country Code',
    callingCode: 'Calling Code',
    currencySymbol : 'Currency Symbol',
    currency: 'Currency',
    currencyFactor: 'Currency Factor',
    phoneNumberPossibleLengths: 'Phone no Length',
    placeValue:'Place Value',
    action: 'Action'
}

export const agencyMasterTemplateStrings = {
    name: 'Agency',
    city: 'City',
    status: 'Status',
    action: 'Action'
};
export const operatorMasterTemplateStrings = {
    id: 'Id',
    name: 'Operator',
    city: 'City',
    phone: 'Phone No',
    email: 'Email Id',
    address: 'Address',
    status: 'Status',
    profilePercent: 'Complete',
    operatorVerified: 'Verified',
    action: 'Action'
};
export const operatorViewTemplateStrings = {
    id: 'Id',
    name: 'Operator',
    city: 'City',
    type: 'Operator Type',
    phone: 'Phone No',
    email: 'Email Id',
    address: 'Address',
    gstCertificate: 'Gst Certificate',
    noOfBuses: 'No of Buses',
    idType:"ID Type",
    accountHolderName:'Account Holder Name',
    accountNumber:'Account Number',
    ifscCode:'Ifsc Code',
    accountType:'Account Type',
    profilePercent: 'Complete',
    operatorVerified: 'Verified',
    status: 'Status',
    action: 'Action'
};
export const depotMasterTemplateStrings = {
    name: 'Depot',
    city: 'City',
    depotType:'Depot Type',
    radius:'Radius(m)',
    latitude:'Latitude',
    longitude:'Longitude',
    status: 'Status',
    action: 'Action'
};

export const masterType = {
    city: 'city',
    country: 'country',
    agency: 'agency',
    operator: 'operator',
    owner: 'owner',
    depot: 'depot',
    camera: 'camera',
    serviceCategory:'serviceCategory',
    language:'language',
    seatingLayout: 'seatingLayout',
};
export const ownerMasterTemplateStrings = {
    ownerCode: 'Owner Code',
    name: 'Owner Name',
    phone: 'Phone No',
    city: 'City',
    operator: 'Operator',
    status: 'Status',
    action: 'Action'
};

export const cameraHeadings ={
    cameraId : "CameraID",
    vehicleNo : "Vehicle No", 
    cameraBrand : "Camera Brand", 
    cameraType : "Camera Type", 
    isActive : 'Status',
    updatedAt:"Updated At",
    action: 'Action'
}

export const cameraHeadingsInView ={
    cameraId : "Camera ID",
    vehicleNo : "Vehicle No", 
    cameraBrand : "Camera Brand", 
    cameraType : "Camera Type", 
    userId:"User Id",
    cameraPassword : "Camera Password",
    simCardNo:"Sim Card No",
    sdCard:"SD Card",
    position:"Position",
    updatedAt:"Updated At",
    createdAt:"Created At",
    isActive:"Status",
    serviceName:"Service Name",
    city:"City",
    configSetStatus:"Config Set Status",
    lastOnlineTime:"Last Online Time",
    passwordMismatch:"Password Mismatch", //NOSONAR
    sdCardPresent:"SD Card Present",
}

export const masterModalConfig = {
    city: {
        createModalTitle: 'Add New City',
        updateModalTitle: 'Update City',
        viewModalTitle: 'City Details'
    },
    country: {
        createModalTitle: 'Add New Country',
        updateModalTitle: 'Update Country',
        viewModalTitle: 'Country Details'
    },
    agency: {
        createModalTitle: 'Add New Agency',
        updateModalTitle: 'Update Agency',
        viewModalTitle: 'Agency Details'
    },
    operator: {
        createModalTitle: 'Add New Operator',
        updateModalTitle: 'Update Operator',
        viewModalTitle: 'Operator Details'

    },
    owner: {
        createModalTitle: 'Add New Owner',
        updateModalTitle: 'Update Owner',
        viewModalTitle: 'Owner Details'
    },
    depot: {
        createModalTitle: 'Add New Depot',
        updateModalTitle: 'Update Depot',
        viewModalTitle: 'Depot Details'
    },
    camera:{
        createModalTitle: 'Add New Camera',
        updateModalTitle: 'Update Camera',
        viewModalTitle: 'Camera Details'
    },
    serviceCategory:{
        createModalTitle: 'Add New Service Category',
        updateModalTitle: 'Update Service Catgory',
        viewModalTitle: 'Service Category Details'
    },
    serviceProvider:{
        createModalTitle: 'Add New Service Provider',
        updateModalTitle: 'Update Service Provider',
        viewModalTitle: 'Service Provider Details'
    },
    language: {
        createModalTitle: 'Add New Language',
        updateModalTitle: 'Update Language',
        viewModalTitle: 'Language Details'
    },
    seatingLayout: {
        createModalTitle: 'Add New Seating Layout',
        updateModalTitle: 'Update Seating Layout',
        viewModalTitle: 'Seating Layout Details'
    }
}

export const ServiceCategoryNameHeading = {
  serviceName: "Service Name",
  serviceId: "Service Id",
  createdAt: "Created At",
  updatedAt: "Updated At",
  agencyCategoryDto: "Agencies",
  action: 'Action'
};
export const SeatingLayoutNameHeading = {
    name : 'Name',
    layoutId : 'Layout ID',
    seatingCapacity :'Seating Capacity',
    updatedAt : 'Updated At',
    createdBy : 'Updated By',
    action:'Action'
}
export const ServiceProviderNameHeading = {
    serviceProviderName: "Service Provider Name",
    serviceProviderId: "Service Provider Id",
    createdAt: "Created At",
    updatedAt: "Updated At",
    agencyProviderDto: "Agencies",
    action: 'Action'
};

export const serviceCategoryViewTemplateStrings = {
    serviceName: "Service Name",
    serviceId: "Service Id",
    createdAt: "Created At",
    updatedAt: "Updated At",
    agencyProviderDto: "Agencies",
    agencyCategoryDto: "Agencies",
    serviceProviderName: "Service Provider Name",
    serviceProviderId: "Service Provider Id",
}

export const LanguageMasterTemplateStrings = {
    cityName:'City',
    country:'Country',
    defaultUILanguage:'Defaut UI Language',
    defaultPrintLanguage:'Default Print Language',
    languages:'Selected Languages',
    action: 'Action'
};

export const ViewLanguageMasterTemplateStrings = {
    cityName:'City',
    country:'Country',
    languageCategoryDto:'Language Category Dto'
};
export const SeatingLayoutTemplateStrings = {
    name : 'Name',
    seatingCapacity :'Seating Capacity',
    createdBy :'Created By',
    createdAt : 'Created At',
    updatedAt : 'Updated At',
    updatedBy : 'Updated By',
    layoutId : 'Layout ID',
    layout : 'Layout'
};